<!--<p class="text-danger fw-bold">variant-swatch-list works!</p>-->

<span class="fw-normal mb-2 d-block">
  {{ 'product-variant-optie-selecteer-kleur-titel' | fromDictionary }}
  <ng-container *ngIf="hoverLabel || getSelectedOptionValue(option.name)">
    -
    <span *ngIf="!hoverLabel">{{ getSelectedOptionValue(option.name) }}</span>

    <span class="color-preview" *ngIf="hoverLabel">{{ hoverLabel }}</span>
  </ng-container>
</span>

<ul class="swatch-list">
  <li class="swatch-list__item" *ngFor="let value of option.values">
    <a
      class="swatch"
      [class.is--active]="getSelectedOptionValue(option.name) === value"
      [class.is--inactive]="!isAvailable(option.name, value)"
      [routerLink]="[]"
      [queryParams]="getOptionAsQueryParam(option, value)"
      [queryParamsHandling]="'merge'"
      [replaceUrl]="true"
      [class.is--white]="
        value.toLowerCase() === 'wit' || value.toLowerCase() === 'white' || (!getSwatch(value).color && !getSwatch(value).image)
      "
      [style.--swatch-color]="getSwatch(value).color || 'white'"
      [style.--swatch-image]="getSwatch(value).image"
      (mouseenter)="hoverLabel = value"
      (mouseleave)="hoverLabel = undefined"
    >
      <span class="sr-only">Choose color: {{ value }}</span>
      <div class="swatch__cross" *ngIf="!isAvailable(option.name, value)"></div>
    </a>
  </li>
</ul>
